import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { I18nModule } from '@spartacus/core';
import { SpinnerModule, PageComponentModule, PageLayoutModule, PageSlotModule } from '@spartacus/storefront';
import { KnBrSSOLayoutConfigModule } from './knbr-new-auth0-sso-layout.config';
import { KnbrNewAuth0SsoComponent } from './knbr-new-auth0-sso.component';

const staticRoutes: Routes = [
  {
    path: 'auth0/callback',
    component: KnbrNewAuth0SsoComponent,
  },
];

@NgModule({
  declarations: [KnbrNewAuth0SsoComponent],
  imports: [
    CommonModule,
    I18nModule,
    SpinnerModule,
    PageComponentModule,
    PageLayoutModule,
    PageSlotModule,
    KnBrSSOLayoutConfigModule,
    RouterModule.forChild(staticRoutes),
  ],
  exports: [KnbrNewAuth0SsoComponent],
})
export class KnbrNewAuth0SsoModule {}
